import {
    Grid,
    Tooltip,
    Typography
} from '@mui/material';
import { useTheme } from '@mui/styles';
import { AdminRoleId } from '@tassat/common-definitions';
import { Information } from '@tassat/icon';
import { PoweredBySymbol } from '@tassat/symbols';
import React from 'react';

import TassatPayLogo from 'Images/TassatLogoAndName.svg';
import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';
import { useAppSelector } from 'Reducers/store/hooks';
import { getCurrentRole, getUser } from 'Selectors/common';
import { useClientLogos } from 'SharedComponents/hooks/useClientLogos';

import ApiOpsDashboard from './apiOpsDashboard';
import OpsAdminDashboard from './opsAdminDashboard';

import type { FirmsDashboardProps } from '.';

export function FirmsDashboard(props: FirmsDashboardProps) {
    const {
        classes,
        setAssetListOverlayOpen
    } = props;

    const userRole = useAppSelector(getCurrentRole);
    const user = useAppSelector(getUser);
    const theme = useTheme<ApplicationMuiTheme>();
    const clientLogoUrls = useClientLogos();

    const {
        usePoweredByImage,
        useTassatPayLogoOnDashboard
    } = theme?.app?.clientTheme.layoutSettings || {};

    const renderUserRoleDashboard = () => {
        if ((userRole.AdminRoleId === AdminRoleId.BANK_OPS ||
            userRole.AdminRoleId === AdminRoleId.BANK_OPS_SUPERVISOR)) {
            return (
                <Grid
                    item
                >
                    <OpsAdminDashboard
                        setAssetListOverlayOpen={setAssetListOverlayOpen}
                    />
                </Grid>
            );
        }

        if (userRole.AdminRoleId === AdminRoleId.API_OPS) {
            return (
                <Grid item>
                    <ApiOpsDashboard />
                </Grid>
            );
        }

        return null;
    };

    return (
        <Grid
            className={classes.globalHeaderDashboard}
            container
            direction='column'
            spacing={0}
            wrap='nowrap'
        >
            {renderUserRoleDashboard()}
            <Grid
                alignItems='flex-end'
                className={classes.dashboardFooter}
                container
                item
                justifyContent='space-between'
            >
                <Grid
                    className={classes.footerLogoContainer}
                    container
                    direction='row'
                    item
                >
                    <Typography>Operated by tZERO Securities, LLC</Typography>
                    <img
                        className={classes.footerLogo}
                        src={clientLogoUrls.ClientColorLogoUrl}
                    />
                    <Tooltip
                        arrow
                        placement='top'
                        title={
                            <>
                                <Typography>
                                    Operated by tZERO Securities, LLC, a SEC registered broker-dealer and FINRA member.
                                    For more information about tZERO Securities, LLC visit{' '}
                                    <a
                                        href='https://brokercheck.finra.org/'
                                        rel='noreferrer'
                                        target='_blank'
                                    >
                                        FINRA’s BrokerCheck
                                    </a>
                                    {' '}and click{' '}
                                    <a
                                        href='https://tzero.com/disclosure-library/'
                                        rel='noreferrer'
                                        target='_blank'
                                    >
                                        here
                                    </a>
                                    {' '}for more information
                                </Typography>
                            </>
                        }
                    >
                        {/* Div needed for tooltip ref */}
                        <div className={classes.tzeroInfoIconContainer}>
                            <Information
                                className={classes.tzeroInfoIcon}
                                iconColor='#4A4C50'
                            />
                        </div>
                    </Tooltip>
                </Grid>
                <Grid
                    className={classes.footerLogoContainer}
                    container
                    direction='row'
                    item
                >
                    <Grid
                        container
                        item
                    >
                        <Typography>Partnered with</Typography>
                        <img
                            className={classes.footerLogo}
                            src='https://storage.googleapis.com/lynq-svgs/arca/svgs/Arca_Horizontal_Color_Logo.png'
                        />
                    </Grid>
                </Grid>
                <Grid
                    className={classes.footerLogoContainer}
                    item
                >
                    {useTassatPayLogoOnDashboard && (usePoweredByImage ?
                        (
                            <PoweredBySymbol
                                isAdmin={user.IsAdmin}
                                orientation='horizontal'
                            />
                        )
                        : (
                            <img
                                className={classes.tassatpayLogo}
                                src={TassatPayLogo}
                            />
                        ))}
                </Grid>
            </Grid>
        </Grid>
    );
}